import { Observable, from } from 'rxjs'

export interface IOService {
  readFile(file: File): Promise<Uint8Array>
  readFile$(file: File): Observable<Uint8Array>
}

export const ioService: IOService = {
  readFile(file: File): Promise<Uint8Array> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader()
      fr.onloadend = () => resolve(new Uint8Array(fr.result as ArrayBuffer))
      fr.onerror = () => reject(fr.error)
      fr.onabort = () => reject(fr.error)
      fr.readAsArrayBuffer(file)
    })
  },
  readFile$(file: File): Observable<Uint8Array> {
    return from(this.readFile(file))
  }
}
